"use client"

import { Button } from "@/components/ui/button"
import Link from "next/link"
import { useAtom } from "jotai"
import { isSubscribeModalOpenAtom } from "@/app/contexts/Atoms"

export default function SubscribeModalButton({
  children,
  url,
  isSubscribed,
  className,
  secondary,
}: {
  children: React.ReactNode
  url: string
  isSubscribed?: boolean
  className?: string
  secondary?: boolean
}) {
  const [isSubscribeModalOpen, setIsSubscribeModalOpen] = useAtom(
    isSubscribeModalOpenAtom
  )

  if (isSubscribed || isSubscribeModalOpen) {
    return (
      <div>
        <Button
          variant={secondary ? "secondary" : undefined}
          disabled={true}
          className={className}
        >
          {children}
        </Button>
      </div>
    )
  }

  return (
    // Note that we cannot do a prefetch on this link because for logged in users that have an email, it will trigger
    // the onComplete in the EnterEmail page and cause the user to auto-subscribe as soon as they navigate to the blog
    // or post page, without even clicking the button.
    <Link href={url}>
      <Button
        variant={secondary ? "secondary" : undefined}
        className={className}
        onClick={() => {
          setIsSubscribeModalOpen(true)
        }}
      >
        {children}
      </Button>
    </Link>
  )
}
